

























































import Vue from 'vue'
import Component from 'vue-class-component'
import Service from '@/modules/reservation/model/Service'
import {Action, Mutation, State} from 'vuex-class'
import {MutationTypes} from '@/modules/reservation/store/mutations'
import ProductListDialog from '@/modules/product/components/ProductListDialog.vue'
import {Watch} from 'vue-property-decorator';
import ConfirmDeleteReservationService from '@/modules/reservation/components/ConfirmDeleteReservationService.vue';
import {Product} from '@/modules/product';

/**
 * Detalle de un servicio
 *
 * Muestra al usuario la información de un servicios de departamento.
 * Además permite editar y actualizar sus campos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ConfirmDeleteReservationService, ProductListDialog},
})
export default class ServiceDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            update (field: string, value: any): void,
            validate (): boolean,
            resetValidation (): void,
        },
    }

    /**
     * Servicio actualmente en edición/visualización
     */
    @State(state => state.reservation.currentService)
    public service: Service

    /**
     * Indica si el componente se encuentra activo y mostrado al usuario
     */
    @State(state => state.reservation.serviceDetail)
    public active: boolean

    /**
     * Activa o desactiva el componente
     */
    @Mutation(`reservation/${MutationTypes.ToggleServiceDetail}`)
    public toggleDetail: (show: boolean) => void

    @Action('reservation/saveService')
    public saveService: () => void

    public productSelect = false
    public productName = ''
    public loadingProduct = false
    public saving = false
    public confirmDeleteService = false
    public rules = {
        name: [
            (v: string) => !!v || 'El nombre es obligatorio',
        ],
        price: [
            (v: string) => !!v || 'El precio es obligatorio',
        ],
    }

    /**
     * Observa la propiedad 'active' que controla la visibilidad del modal.
     *
     * @param value
     */
    @Watch('active')
    public onDisplay (value: boolean) {
        if (!value) {
            return
        }

        if (this.$refs.form) {
            this.$refs.form.resetValidation()
        }

        this.productName = ''
    }

    /**
     * Método invocado cuando el usuario selecciona un producto de la tienda para
     * el servicio
     *
     * @param product
     */
    public selectProduct (product: Product) {
        this.$refs.form.update('unigestId', product.id)
        this.$refs.form.update('price', product.pvpIva)

        this.productName = product.name

        // Desactiva la pantalla de selección del producto
        this.productSelect = false
        this.loadingProduct = false
    }

    public async save () {
        if (!this.$refs.form.validate()) {
            return
        }

        this.saving = true
        await this.saveService()
        this.saving = false
    }
}
